<template>
  <div class="flex">
    <ul class="flex flex-wrap">
      <li v-for="(item, index) in searchConfig" :key="index" class="mr-3 mb-4">
        <el-date-picker
          v-if="item.type === 'daterange'"
          :style="{ width: item.width || '168px' }"
          v-model="formInline[item.prop]"
          :value-format="item.format || 'yyyy-MM-dd'"
          :format="item.format || 'yyyy-MM-dd'"
          :type="item.dateType || 'daterange'"
          range-separator="至"
          :start-placeholder="item.startPlaceholder || '开始日期'"
          :end-placeholder="item.endPlaceholder || '结束日期'"
        >
        </el-date-picker>

        <el-select
          v-else-if="item.type === 'select'"
          v-model="formInline[item.prop]"
          :style="{ width: item.width || '168px' }"
          :placeholder="item.placeholder || '请输入'"
          size="small"
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <el-input
          v-else
          v-model="formInline[item.prop]"
          :style="{ width: item.width || '168px' }"
          :placeholder="item.placeholder || '请输入'"
          size="small"
        >
        </el-input>
      </li>
      <li class="mb-4" style="width: 140px">
        <el-button class="mr-0.5 px-0" style="width: 60px" size="small" type="primary" @click="toSearch">
          <span class="px-0.5">查询</span>
        </el-button>
        <el-button class="px-0" size="small" style="width: 60px" type="primary" plain @click="onReset">
          <span class="px-0.5">重置</span>
        </el-button>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    searchConfig: {
      type: Array,
      default: () => []
    },
    defaultData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      formInline: {}
    }
  },
  methods: {
    toSearch() {
      this.$emit('to-search', this.formInline)
    },
    onReset() {
      this.clearData()
      this.$emit('on-reset')
    },
    clearData() {
      this.formInline = {}
    }
  },
  watch: {
    defaultData:{
      deep: true,
      handler(newVal){
        this.formInline = JSON.parse(JSON.stringify(newVal))
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
